import { render } from "./ProductsManager.vue?vue&type=template&id=032e82cb&scoped=true"
import script from "./ProductsManager.vue?vue&type=script&lang=js"
export * from "./ProductsManager.vue?vue&type=script&lang=js"

import "./custom-product-manager.scss?vue&type=style&index=0&id=032e82cb&lang=scss&scoped=true"
import "./ProductsManager.vue?vue&type=style&index=1&id=032e82cb&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-032e82cb"]])

export default __exports__